import { useNavigate } from 'react-router-dom'
import { Heading, Tabset } from '@quickmd-llc/design-system'
import { Breadcrumb } from '@/components/breadcrumb/Breadcrumb'
import { MANAGEMENT_PAGE_ROUTE } from '@/utils/constants'
import { tabNames } from '../Constants'

const TABS = [
  { label: tabNames.GENERAL, value: tabNames.GENERAL },
  { label: tabNames.LICENSE_AND_PRODUCTIVITY, value: tabNames.LICENSE_AND_PRODUCTIVITY },
  { label: tabNames.CALENDAR, value: tabNames.CALENDAR },
]

interface PageHeaderProps {
  providerName: string
  activeTab: string
  onTabChange: (tab: string) => void
  showTabs: boolean
  disabled?: boolean
}

export function PageHeader({ providerName, activeTab, onTabChange, showTabs, disabled }: PageHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className='flex w-full flex-col items-start justify-end gap-sp-2'>
      <div className='flex w-full items-end'>
        <div className='flex flex-1 flex-col items-start justify-center'>
          <Breadcrumb
            crumbs={[
              {
                label: 'Management',
                onClick: () => {
                  void navigate(MANAGEMENT_PAGE_ROUTE)
                },
              },
              { label: providerName },
            ]}
          />
          <Heading level='h1'>{providerName}</Heading>
        </div>
      </div>
      {showTabs ?
        <Tabset
          tabs={TABS}
          activeTab={activeTab}
          onTabChange={onTabChange}
          className='w-full'
          disabled={disabled ?? false}
        />
      : null}
    </div>
  )
}
